// Copyright (c) 2019 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.wearParts.claim,
    formValidation: state.claims.wearParts.formValidation,
    isEditable: state.claims.wearParts.isEditable,
    isValidClaim: state.claims.wearParts.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    product: state.claims.wearParts.product,
    rgaStatus: state.claims.wearParts.rgaStatus,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/wear-parts/components/claim-details-section/index.js